(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-yancah-fv"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    // CSSのブレークポイント（min-width: 750px）と一致させること
    const desktopMediaQuery = window.matchMedia('(min-width: 750px)');

    // スライド内の全 <video>（表示状態を問わない）
    const getAllSlideVideos = (slide) =>
      Array.from(slide.querySelectorAll('[data-fv-video]'));

    // 現在のビューポートで実際に表示されている <video> のみ
    const getVisibleSlideVideos = (slide) => {
      const selector = desktopMediaQuery.matches
        ? '.rw-yancah-fv__video--desktop[data-fv-video]'
        : '.rw-yancah-fv__video--mobile[data-fv-video]';

      const matched = Array.from(slide.querySelectorAll(selector));

      // 片側しか存在しない構成へのフォールバック
      return matched.length > 0 ? matched : getAllSlideVideos(slide);
    };

    const pauseSlideVideos = (slide) => {
      // 停止は「全ての」動画に対して行う（画面回転時の取りこぼし防止）。
      // ★ここに video.currentTime = 0 を書かないこと★
      // iPhoneで動画が一切再生されなくなる。冒頭に戻すのは playSlideVideos 側で実施済み。
      getAllSlideVideos(slide).forEach((video) => {
        video.pause();
      });
    };

    const playSlideVideos = (slide) => {
      // 再生は「表示されている」動画のみに限定する。
      // display:none の動画も再生・ダウンロードされてしまう問題を防ぐ。
      getVisibleSlideVideos(slide).forEach((video) => {
        // 冒頭に戻す処理はここだけで行う。
        // 表示する1本のみ対象＋直後に再生するため、pauseSlideVideos 側の不具合は起きない。
        if (video.currentTime > 0.05) {
          try {
            video.currentTime = 0;
          } catch (error) {
            /* ignore */
          }
        }

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    };

    const initFvCarousel = (root) => {
      if (root.dataset.initialized === 'true') return;

      const slides = Array.from(root.querySelectorAll('[data-fv-slide]'));
      if (slides.length === 0) return;

      root.dataset.initialized = 'true';

      const interval = Number.parseInt(root.dataset.autoplayInterval || '5000', 10);
      const showDots = root.dataset.showDots === 'true';
      const dots = showDots ? Array.from(root.querySelectorAll('[data-fv-dot]')) : [];
      const enableAutoplay = slides.length > 1 && !reducedMotionQuery.matches;

      let currentIndex = 0;
      let timer = null;
      let remaining = interval;   // 次の切り替えまでの残り時間(ms)
      let scheduledAt = 0;        // 現在のタイマーを開始した時刻(performance.now())
      let isDocumentVisible = document.visibilityState === 'visible';

      // 動画の再生開始を待ってからタイマーを起動するための状態
      let waitingForPlay = false;   // 現在 playing 待ちかどうか
      let fallbackTimer = null;     // playing が来ない場合の保険
      let boundVideo = null;        // 監視中の video 要素

      const PLAY_WAIT_FALLBACK_MS = 3000;   // 保険の待機上限

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === currentIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        if (index === currentIndex || index < 0 || index >= slides.length) return;

        const previousSlide = slides[currentIndex];
        const nextSlide = slides[index];

        previousSlide.classList.remove('is-active');
        previousSlide.setAttribute('aria-hidden', 'true');
        pauseSlideVideos(previousSlide);

        currentIndex = index;

        nextSlide.classList.add('is-active');
        nextSlide.setAttribute('aria-hidden', 'false');
        playSlideVideos(nextSlide);
        updateDots();
        startTimerForSlide(nextSlide);   // 動画なら再生開始を待つ
        preloadNextSlide();              // さらに次のスライドを先読み
      };

      const goNext = () => {
        goTo((currentIndex + 1) % slides.length);
      };

      // タイマーを破棄する（残り時間は保持しない）
      const clearTimer = () => {
        if (timer !== null) {
          window.clearTimeout(timer);
          timer = null;
        }
      };

      // 現在の remaining 分だけタイマーを仕掛ける
      const scheduleNext = () => {
        clearTimer();

        if (!enableAutoplay || !isDocumentVisible) return;

        scheduledAt = performance.now();
        timer = window.setTimeout(() => {
          timer = null;
          remaining = interval;
          goNext();   // goTo 内で startTimerForSlide が呼ばれる
        }, remaining);
      };

      // 動画の再生開始を待つ処理を解除する
      const clearPlayWait = () => {
        if (fallbackTimer !== null) {
          window.clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }

        if (boundVideo) {
          boundVideo.removeEventListener('playing', onVideoPlaying);
          boundVideo.removeEventListener('waiting', onVideoWaiting);
          boundVideo.removeEventListener('timeupdate', onVideoTimeUpdate);
          boundVideo = null;
        }

        waitingForPlay = false;
      };

      // 再生が始まった／再開した
      function onVideoPlaying() {
        if (waitingForPlay) {
          // 初回の再生開始：ここからカウント開始
          waitingForPlay = false;

          if (fallbackTimer !== null) {
            window.clearTimeout(fallbackTimer);
            fallbackTimer = null;
          }

          restartAutoplay();
        } else {
          // バッファ切れからの復帰：残り時間から再開
          resumeAutoplay();
        }
      }

      // バッファ切れで映像が止まった
      function onVideoWaiting() {
        if (waitingForPlay) return;   // まだ開始前なら何もしない
        pauseAutoplay();
      }

      // waiting で止めた後に playing が来ないケースの保険。
      // 再生位置が進んでいれば、タイマーを再開する。
      function onVideoTimeUpdate() {
        if (waitingForPlay) return;              // まだ開始前
        if (timer !== null) return;              // すでに動作中
        if (!boundVideo || boundVideo.paused) return;   // 再生していない
        resumeAutoplay();
      }

      // スライド表示時に呼ぶ。動画があれば再生開始を待つ
      const startTimerForSlide = (slide) => {
        clearPlayWait();
        clearTimer();

        const videos = getVisibleSlideVideos(slide);

        // 画像スライドは従来どおり即座に起動
        if (!videos.length) {
          restartAutoplay();
          return;
        }

        boundVideo = videos[0];
        waitingForPlay = true;

        boundVideo.addEventListener('playing', onVideoPlaying);
        boundVideo.addEventListener('waiting', onVideoWaiting);
        boundVideo.addEventListener('timeupdate', onVideoTimeUpdate);
        // stalled は購読しない。完全バッファ後のネットワーク静止でも発火し、
        // 再生中なのにタイマーを止めて復帰不能になる。停止判定は waiting のみ。

        // 保険：playing が来なくても必ず動かす
        fallbackTimer = window.setTimeout(() => {
          fallbackTimer = null;
          if (!waitingForPlay) return;
          waitingForPlay = false;
          restartAutoplay();
        }, PLAY_WAIT_FALLBACK_MS);
      };

      // 指定スライドの動画を先読みする。
      // Liquid 側は preload="metadata" のままにし、ここで表示対象のみ auto に変える。
      // （HTML属性で auto にすると、非表示側の動画まで読み込まれ通信量が倍になる）
      const preloadSlideVideos = (slide) => {
        if (!slide) return;

        getVisibleSlideVideos(slide).forEach((video) => {
          if (video.preload === 'auto') return;   // 先読み済みなら何もしない

          video.preload = 'auto';

          // ★再生中の動画に load() を呼ばないこと★
          // load() は再生を中断してメディア要素を初期状態に戻すため、
          // 表示中スライドの動画が再生されなくなる。
          if (!video.paused) return;

          video.load();
        });
      };

      // 次のスライドを先読みする
      const preloadNextSlide = () => {
        const nextIndex = (currentIndex + 1) % slides.length;
        if (nextIndex === currentIndex) return;   // スライドが1枚の場合

        preloadSlideVideos(slides[nextIndex]);
      };

      // 経過分を差し引いて残り時間を保持したまま停止する
      const pauseAutoplay = () => {
        if (timer === null) return;

        const elapsed = performance.now() - scheduledAt;
        remaining = Math.max(0, remaining - elapsed);
        clearTimer();
      };

      // 保持している残り時間から再開する
      const resumeAutoplay = () => {
        scheduleNext();
      };

      // 残り時間をリセットして最初から計測し直す
      const restartAutoplay = () => {
        remaining = interval;
        scheduleNext();
      };

      slides.forEach((slide, index) => {
        const isActive = index === 0;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (!isActive) {
          pauseSlideVideos(slide);
        }
      });

      // 先読みは再生開始より前に行うこと。
      // 後にすると load() が再生を中断してしまう。
      preloadSlideVideos(slides[currentIndex]);
      preloadNextSlide();

      playSlideVideos(slides[0]);
      updateDots();

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const targetIndex = Number.parseInt(dot.dataset.slideIndex || '0', 10);

          // 表示中のスライドを再度クリックした場合、goTo が早期リターンして
          // startTimerForSlide が呼ばれずタイマーが止まるため、直接呼ぶ。
          if (targetIndex === currentIndex) {
            startTimerForSlide(slides[currentIndex]);
            return;
          }

          goTo(targetIndex);   // 内部で startTimerForSlide が呼ばれる
        });
      });

      const onVisibilityChange = () => {
        isDocumentVisible = document.visibilityState === 'visible';

        if (isDocumentVisible) {
          playSlideVideos(slides[currentIndex]);

          // 動画は 0 秒から再生し直されるため、離脱前の残り時間は使わない。
          // resumeAutoplay() だと再生位置とタイマーがずれる。
          startTimerForSlide(slides[currentIndex]);
        } else {
          pauseSlideVideos(slides[currentIndex]);
          pauseAutoplay();
          clearPlayWait();   // 待機状態を解除（復帰時に再設定される）
        }
      };

      document.addEventListener('visibilitychange', onVisibilityChange);

      const onReducedMotionChange = () => {
        if (reducedMotionQuery.matches) {
          clearTimer();
        } else {
          restartAutoplay();
        }
      };

      if (typeof reducedMotionQuery.addEventListener === 'function') {
        reducedMotionQuery.addEventListener('change', onReducedMotionChange);
      } else if (typeof reducedMotionQuery.addListener === 'function') {
        reducedMotionQuery.addListener(onReducedMotionChange);
      }

      startTimerForSlide(slides[currentIndex]);

      root._yancahFvCleanup = () => {
        clearTimer();
        clearPlayWait();   // イベントリスナとフォールバックを解除
        document.removeEventListener('visibilitychange', onVisibilityChange);

        if (typeof reducedMotionQuery.removeEventListener === 'function') {
          reducedMotionQuery.removeEventListener('change', onReducedMotionChange);
        } else if (typeof reducedMotionQuery.removeListener === 'function') {
          reducedMotionQuery.removeListener(onReducedMotionChange);
        }

        slides.forEach(pauseSlideVideos);
        root.dataset.initialized = 'false';
      };
    };

    const initAll = () => {
      document.querySelectorAll('[data-rw-yancah-fv]').forEach((root) => {
        if (typeof root._yancahFvCleanup === 'function') {
          root._yancahFvCleanup();
        }

        initFvCarousel(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const root = event.target.querySelector('[data-rw-yancah-fv]');
      if (root) {
        if (typeof root._yancahFvCleanup === 'function') {
          root._yancahFvCleanup();
        }

        initFvCarousel(root);
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.querySelector('[data-rw-yancah-fv]');
      if (root && typeof root._yancahFvCleanup === 'function') {
        root._yancahFvCleanup();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-yancha-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const MOBILE_MEDIA = window.matchMedia('(max-width: 749px)');

    const initMobileCarousel = (media) => {
      if (!media || !media.classList.contains('is-mobile-slider')) return;

      const track = media.querySelector('[data-mobile-track]');
      const pagination = media.querySelector('[data-mobile-pagination]');
      const prevButton = media.querySelector('[data-mobile-prev]');
      const nextButton = media.querySelector('[data-mobile-next]');
      const realSlides = Array.from(media.querySelectorAll('[data-mobile-slide]'));

      if (!track || realSlides.length < 2 || !pagination) return;
      if (media.dataset.mobileCarouselInitialized === 'true') return;
      media.dataset.mobileCarouselInitialized = 'true';

      const realCount = realSlides.length;
      const leadingClone = realSlides[realCount - 1].cloneNode(true);
      leadingClone.dataset.mobileSlideClone = 'leading';
      leadingClone.setAttribute('aria-hidden', 'true');
      leadingClone.removeAttribute('data-mobile-slide');

      const trailingClone = realSlides[0].cloneNode(true);
      trailingClone.dataset.mobileSlideClone = 'trailing';
      trailingClone.setAttribute('aria-hidden', 'true');
      trailingClone.removeAttribute('data-mobile-slide');

      track.insertBefore(leadingClone, realSlides[0]);
      track.appendChild(trailingClone);

      const physicalSlides = Array.from(track.querySelectorAll('.rw-yancha-header__mobile-slide'));
      const trailingPhysicalIndex = realCount + 1;

      const autoplayEnabled = media.getAttribute('data-mobile-autoplay') === 'true';
      const autoplayInterval = Number.parseInt(media.getAttribute('data-mobile-autoplay-interval'), 10) || 4000;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let currentSlide = 0;
      let dots = [];
      let isProgrammaticScroll = false;
      let isLoopTransition = false;
      let autoplayTimer = null;
      let resumeTimer = null;
      let cloneResetTimer = null;
      let dotSyncTimer = null;
      let isAutoplayPaused = false;

      const getRealIndexFromPhysical = (physicalIndex) => {
        if (physicalIndex === 0) return realCount - 1;
        if (physicalIndex === trailingPhysicalIndex) return 0;
        return physicalIndex - 1;
      };

      const getPhysicalIndexFromReal = (realIndex) => realIndex + 1;

      const getSlideScrollLeft = (physicalIndex) => {
        const slide = physicalSlides[physicalIndex];
        if (!slide) return 0;

        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        return Math.max(0, slideCenter - track.clientWidth / 2);
      };

      const getNearestPhysicalIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let nearestIndex = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        physicalSlides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - trackCenter);

          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      };

      const waitForScrollEnd = (callback) => {
        if ('onscrollend' in track) {
          track.addEventListener('scrollend', callback, { once: true });
          return;
        }

        let lastScrollLeft = track.scrollLeft;
        let stableFrames = 0;

        const check = () => {
          if (track.scrollLeft === lastScrollLeft) {
            stableFrames += 1;
            if (stableFrames >= 4) {
              callback();
              return;
            }
          } else {
            stableFrames = 0;
            lastScrollLeft = track.scrollLeft;
          }

          window.requestAnimationFrame(check);
        };

        window.requestAnimationFrame(check);
      };

      const jumpToPhysical = (physicalIndex) => {
        if (dotSyncTimer) {
          window.clearTimeout(dotSyncTimer);
          dotSyncTimer = null;
        }

        isProgrammaticScroll = true;
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = getSlideScrollLeft(physicalIndex);
        currentSlide = getRealIndexFromPhysical(physicalIndex);
        updateDots();
        track.offsetHeight;
        track.style.scrollSnapType = '';
        track.style.scrollBehavior = '';

        window.setTimeout(() => {
          isProgrammaticScroll = false;
        }, 50);
      };

      const resetClonePositionIfNeeded = () => {
        if (isProgrammaticScroll || isLoopTransition) return;

        const nearestPhysical = getNearestPhysicalIndex();

        if (nearestPhysical === 0) {
          jumpToPhysical(realCount);
          return;
        }

        if (nearestPhysical === trailingPhysicalIndex) {
          jumpToPhysical(1);
        }
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      const startAutoplay = () => {
        stopAutoplay();

        if (
          !autoplayEnabled ||
          prefersReducedMotion ||
          !MOBILE_MEDIA.matches ||
          isAutoplayPaused ||
          physicalSlides[1].offsetWidth === 0
        ) {
          return;
        }

        autoplayTimer = window.setInterval(() => {
          if (isLoopTransition || isAutoplayPaused) return;

          if (currentSlide === realCount - 1) {
            isLoopTransition = true;
            scrollToPhysical(trailingPhysicalIndex, {
              behavior: 'smooth',
              onComplete: () => {
                jumpToPhysical(1);
                isLoopTransition = false;
              },
            });
            return;
          }

          scrollToRealSlide(currentSlide + 1, { behavior: 'auto' });
        }, autoplayInterval);
      };

      const pauseAutoplay = (resumeAfter = autoplayInterval) => {
        if (!autoplayEnabled || prefersReducedMotion) return;

        isAutoplayPaused = true;
        stopAutoplay();

        if (resumeTimer) {
          window.clearTimeout(resumeTimer);
        }

        resumeTimer = window.setTimeout(() => {
          isAutoplayPaused = false;
          startAutoplay();
        }, resumeAfter);
      };

      const getRealIndexFromScroll = () => {
        return getRealIndexFromPhysical(getNearestPhysicalIndex());
      };

      const syncDotsFromScroll = () => {
        const realIndex = getRealIndexFromScroll();

        if (realIndex === currentSlide) {
          return;
        }

        currentSlide = realIndex;
        updateDots();
      };

      const scheduleDotsSyncFromScroll = () => {
        if (dotSyncTimer) {
          window.clearTimeout(dotSyncTimer);
        }

        dotSyncTimer = window.setTimeout(() => {
          dotSyncTimer = null;
          syncDotsFromScroll();
        }, 80);
      };

      const finishProgrammaticScroll = () => {
        isProgrammaticScroll = false;
        syncDotsFromScroll();
      };

      const scrollToPhysical = (
        physicalIndex,
        { behavior = 'smooth', userInitiated = false, onComplete = null } = {}
      ) => {
        const targetIndex = Math.max(0, Math.min(physicalIndex, trailingPhysicalIndex));

        if (userInitiated) {
          pauseAutoplay();
        }

        if (dotSyncTimer) {
          window.clearTimeout(dotSyncTimer);
          dotSyncTimer = null;
        }

        isProgrammaticScroll = true;
        track.scrollTo({
          left: getSlideScrollLeft(targetIndex),
          behavior,
        });

        waitForScrollEnd(() => {
          if (onComplete) {
            onComplete();
            return;
          }

          finishProgrammaticScroll();
        });
      };

      const scrollToRealSlide = (realIndex, options = {}) => {
        scrollToPhysical(getPhysicalIndexFromReal(realIndex), options);
      };

      const goToNext = ({ userInitiated = true } = {}) => {
        if (isLoopTransition) return;

        if (currentSlide === realCount - 1) {
          isLoopTransition = true;
          scrollToPhysical(trailingPhysicalIndex, {
            behavior: 'smooth',
            userInitiated,
            onComplete: () => {
              jumpToPhysical(1);
              isLoopTransition = false;
            },
          });
          return;
        }

        scrollToRealSlide(currentSlide + 1, { behavior: 'smooth', userInitiated });
      };

      const goToPrev = ({ userInitiated = true } = {}) => {
        if (isLoopTransition) return;

        if (currentSlide === 0) {
          isLoopTransition = true;
          scrollToPhysical(0, {
            behavior: 'smooth',
            userInitiated,
            onComplete: () => {
              jumpToPhysical(realCount);
              isLoopTransition = false;
            },
          });
          return;
        }

        scrollToRealSlide(currentSlide - 1, { behavior: 'smooth', userInitiated });
      };

      const updateDots = () => {
        dots.forEach((dot, index) => {
          const isActive = index === currentSlide;

          if (isActive) {
            dot.classList.add('is-active');
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.classList.remove('is-active');
            dot.removeAttribute('aria-current');
          }
        });
      };

      const buildDots = () => {
        pagination.innerHTML = '';
        dots = [];

        for (let index = 0; index < realCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rw-yancha-header__mobile-dot';
          dot.dataset.mobileDot = '';
          dot.setAttribute('aria-label', `${index + 1}枚目`);
          dot.addEventListener('click', () => {
            scrollToRealSlide(index, { userInitiated: true });
          });
          pagination.appendChild(dot);
          dots.push(dot);
        }

        updateDots();
      };

      const syncFromScroll = () => {
        if (isProgrammaticScroll || isLoopTransition) return;

        scheduleDotsSyncFromScroll();

        if (cloneResetTimer) {
          window.clearTimeout(cloneResetTimer);
        }

        cloneResetTimer = window.setTimeout(resetClonePositionIfNeeded, 120);
      };

      const bootstrap = () => {
        if (MOBILE_MEDIA.matches && physicalSlides[1].offsetWidth === 0) {
          window.requestAnimationFrame(bootstrap);
          return;
        }

        buildDots();
        jumpToPhysical(1);
        startAutoplay();
      };

      bootstrap();

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          goToPrev({ userInitiated: true });
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          goToNext({ userInitiated: true });
        });
      }

      track.addEventListener('scroll', syncFromScroll, { passive: true });
      track.addEventListener('pointerdown', () => pauseAutoplay(), { passive: true });

      MOBILE_MEDIA.addEventListener('change', () => {
        if (MOBILE_MEDIA.matches) {
          window.requestAnimationFrame(() => {
            jumpToPhysical(getPhysicalIndexFromReal(currentSlide));
            startAutoplay();
          });
        } else {
          stopAutoplay();
        }
      });
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-rw-yancha-header-media]').forEach(initMobileCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-rw-yancha-header-media]').forEach(initMobileCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rw-yancha-stamp-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const DESKTOP_ITEMS_PER_PAGE = 15;
    const MOBILE_ITEMS_PER_PAGE = 15;
    const MOBILE_FIXED_GRID_MAX = 6;
    const DESKTOP_MEDIA = window.matchMedia('(min-width: 750px)');

    const getItemsPerPage = () => (DESKTOP_MEDIA.matches ? DESKTOP_ITEMS_PER_PAGE : MOBILE_ITEMS_PER_PAGE);

    const initStampCollection = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const preview = root.querySelector('.rw-yancha-stamp-collection__preview-image');
      const grid = root.querySelector('[data-stamp-grid]');
      const items = Array.from(root.querySelectorAll('[data-stamp-item]'));
      const pagination = root.querySelector('[data-stamp-pagination]');
      const dotsContainer = root.querySelector('[data-stamp-dots]');
      const prevBtn = root.querySelector('[data-stamp-prev]');
      const nextBtn = root.querySelector('[data-stamp-next]');

      if (!preview || items.length === 0 || !grid || !pagination || !dotsContainer) return;

      let currentPage = 0;
      let totalPages = 1;

      const updateArrowState = () => {
        if (prevBtn) prevBtn.disabled = currentPage <= 0;
        if (nextBtn) nextBtn.disabled = currentPage >= totalPages - 1;
      };

      const updateGridHeight = () => {
        if (!DESKTOP_MEDIA.matches) {
          const visibleCount = items.filter((item) => !item.hidden).length;
          grid.classList.toggle(
            'rw-yancha-stamp-collection__grid--fixed-sp-height',
            visibleCount > 0 && visibleCount <= MOBILE_FIXED_GRID_MAX
          );
          return;
        }

        grid.classList.remove('rw-yancha-stamp-collection__grid--fixed-sp-height');
      };

      const clearSelection = () => {
        grid.classList.remove('has-sp-selection');
        items.forEach((entry) => {
          entry.classList.remove('is-active');
          entry.setAttribute('aria-pressed', 'false');
        });
      };

      const selectItem = (item) => {
        grid.classList.add('has-sp-selection');

        items.forEach((entry) => {
          entry.classList.remove('is-active');
          entry.setAttribute('aria-pressed', 'false');
        });

        item.classList.add('is-active');
        item.setAttribute('aria-pressed', 'true');
        preview.src = item.dataset.previewSrc;

        if (item.dataset.previewSrcset) {
          preview.srcset = item.dataset.previewSrcset;
        } else {
          preview.removeAttribute('srcset');
        }

        preview.alt = item.dataset.previewAlt || '';
      };

      items.forEach((item) => {
        item.addEventListener('click', () => selectItem(item));
      });

      root.addEventListener('click', (event) => {
        if (DESKTOP_MEDIA.matches) return;
        if (!grid.classList.contains('has-sp-selection')) return;
        if (event.target.closest('[data-stamp-item]')) return;
        if (event.target.closest('[data-stamp-dot]')) return;

        clearSelection();
      });

      const updateVisibleItems = () => {
        const itemsPerPage = getItemsPerPage();
        const start = currentPage * itemsPerPage;
        const end = start + itemsPerPage;

        items.forEach((item, index) => {
          item.hidden = index < start || index >= end;
        });

        dotsContainer.querySelectorAll('[data-stamp-dot]').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentPage);
          dot.setAttribute('aria-current', index === currentPage ? 'true' : 'false');
        });

        updateGridHeight();
        updateArrowState();
      };

      const goToPage = (page) => {
        currentPage = page;
        if (!DESKTOP_MEDIA.matches) {
          clearSelection();
        }
        updateVisibleItems();
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          if (currentPage > 0) goToPage(currentPage - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          if (currentPage < totalPages - 1) goToPage(currentPage + 1);
        });
      }

      const renderPagination = () => {
        const itemsPerPage = getItemsPerPage();
        totalPages = Math.ceil(items.length / itemsPerPage);

        if (totalPages <= 1) {
          pagination.hidden = true;
          dotsContainer.innerHTML = '';
          items.forEach((item) => {
            item.hidden = false;
          });
          updateGridHeight();
          return;
        }

        pagination.hidden = false;
        dotsContainer.innerHTML = '';

        for (let pageIndex = 0; pageIndex < totalPages; pageIndex += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'rw-yancha-stamp-collection__dot';
          dot.dataset.stampDot = '';
          dot.setAttribute('aria-label', `ページ ${pageIndex + 1}`);
          dot.setAttribute('aria-current', pageIndex === currentPage ? 'true' : 'false');

          if (pageIndex === currentPage) {
            dot.classList.add('is-active');
          }

          dot.addEventListener('click', () => goToPage(pageIndex));
          dotsContainer.appendChild(dot);
        }

        if (currentPage >= totalPages) {
          currentPage = 0;
        }

        updateVisibleItems();
      };

      renderPagination();

      DESKTOP_MEDIA.addEventListener('change', () => {
        currentPage = 0;
        renderPagination();
      });
    };

    const initAll = () => {
      document.querySelectorAll('[data-rw-yancha-stamp-collection]').forEach(initStampCollection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-rw-yancha-stamp-collection]');
      if (section) initStampCollection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
